import classes from "./QuotationOverview.module.css";

import { useSelector } from "react-redux";

import { generateDatesBetween, numberWithCommas } from "../UI/Helper";

import BookingCurrencyConverter from "./BookingCurrencyConverter";

import ItemDescription from "../UI/ItemDescription";
import AirportTransfers from "./AirportTransfers";

import PriceItemOutput from "../UI/PriceItemOutput";
import { useEffect } from "react";

import { quoteActions } from "../../store/quote-slice";

import { bookingActions } from "../../store/booking-slice";

import { useDispatch } from "react-redux";

import Button from "../UI/Button";

import { popupActions } from "../../store/popup-slice";

import React, { useState } from 'react';

import ProgramDropDown from "./ProgramDropDown";

import AmityUSPHighlight from "./AmityUSPHighlight";

import CopyQuoteLinkButton from "./CopyQuoteLinkButton";

import { parse, format, isBefore } from "date-fns";

const TAXI_THB_BEFORE_NOV_2026 = 1000;
const TAXI_THB_FROM_NOV_2026 = 1100;
const TAXI_PRICE_INCREASE_DATE = parse("01/11/2026", "dd/MM/yyyy", new Date());

/** Pickup priced on arrival date; drop-off on departure. dd/MM/yyyy from booking state. */
const taxiLegPriceThb = (dateStr) => {
  if (!dateStr) return TAXI_THB_BEFORE_NOV_2026;
  const d = parse(dateStr, "dd/MM/yyyy", new Date());
  if (Number.isNaN(d.getTime())) return TAXI_THB_BEFORE_NOV_2026;
  return isBefore(d, TAXI_PRICE_INCREASE_DATE) ? TAXI_THB_BEFORE_NOV_2026 : TAXI_THB_FROM_NOV_2026;
};

//import SpecialPromotion from "../Redundant/SpecialPromotion";

// import AccommodationPref from './AccommodationPref'

const QuotationOverview = () => {
  const dispatch = useDispatch();

  const checkInDate = 
    useSelector((state) => state.booking.checkInDate)
  ;
  const checkOutDate = 
    useSelector((state) => state.booking.checkOutDate)
  ;


  
  const datesBetween = generateDatesBetween(checkInDate, checkOutDate);
  // console.log("Check-in Date:", checkInDate);
  // console.log("Check-out Date:", checkOutDate);
  // console.log(datesBetween);

   //Accommodaiton nights will be date of arrival to one date before check out date
  const accommodationDates = datesBetween.slice(0, -1);
  //Program starts one day after arrival and last full day of program is one day before leaving, last day is just colonic and breakfast
  const programDates = datesBetween.slice(1, -1);

   const forexCurrencyTicker = useSelector(
    (state) => state.quote.forexCurrencyTicker
  );

  const forexCurrencyRate = useSelector(
    (state) => state.quote.forexCurrencyRate
  );

  const extraBed = useSelector((state) => state.quote.extraBed);

  const forexSelected = forexCurrencyTicker !== "THB";

  const accommodationNights = accommodationDates.length;
  const programDays = programDates.length;

  let accommodationPref = useSelector((state) => state.quote.accomPref);

  switch (accommodationPref) {
    case "ground":
      accommodationPref = "Ground Floor";
      break;
    case "first":
      accommodationPref = "First Floor";
      break;
    case "bamboo":
        accommodationPref = "Bamboo Haven";
        break;
    default:
      accommodationPref = "No Preference";
  }

  const accommodationPrefClickHandlerToggle = (event) => {
    dispatch(popupActions.setAccommodationPopupShow());
  };

  const ReturningPopupShowGuestOne = (event) => {
    dispatch(popupActions.setReturningPopupShowGuestOne());
  };

  const ReturningPopupShowGuestTwo = (event) => {
    dispatch(popupActions.setReturningPopupShowGuestTwo());
  };

  const guest1ReturningToggleHandler = (event) => {
    dispatch(bookingActions.setGuest1ReturningToggle());
  };

  const guest2ReturningToggleHandler = (event) => {
    dispatch(bookingActions.setGuest2ReturningToggle());
  };

  // const ProgramPopupShowHandler = (event) => {
  //   dispatch(popupActions.setProgramPopupShow());
  // };

  useEffect(() => {
    dispatch(
      bookingActions.setAccommNightsProgramDays({
        accommNights: accommodationNights,
        programDays: programDays,
      })
    );
  }, [accommodationNights, programDays, dispatch]);

  const totalGuests = useSelector((state) => state.booking.totalGuests);
  const totalRooms = useSelector((state) => state.booking.totalRooms);

  const guest1Returning = useSelector((state) => state.booking.guest1Returning);
  const guest2Returning = useSelector((state) => state.booking.guest2Returning);

  let guest1ReturningEmail = useSelector(
    (state) => state.booking.guest1ReturningEmail
  );

  let guest2ReturningEmail = useSelector(
    (state) => state.booking.guest2ReturningEmail
  );

  if (guest1ReturningEmail) {
    guest1ReturningEmail = `Welcome Back! (${guest1ReturningEmail})`;
  }

  if (guest2ReturningEmail) {
    guest2ReturningEmail = `Welcome Back! (${guest2ReturningEmail})`;
  }


  const specialRates = useSelector(
    (state) => state.rates.specialRates
  );
  const defaultRate = useSelector(
    (state) => state.rates.defaultRate
  );

  const getDiscountsForDate = (dateString) => {
    const specialRate = specialRates.find(rate => {
      return dateString === rate.date;
    });
    if (specialRate) {
      return { 
        newGuestDiscount: specialRate.newGuestDiscount,
        returningGuestDiscount: specialRate.returningGuestDiscount,
        promotionName: specialRate.name
      };
    } else {
      return { 
        newGuestDiscount: defaultRate.newGuestDiscount,
        returningGuestDiscount: defaultRate.returningGuestDiscount,
        promotionName: 'default'
      };
    }
  };

  // Parse your stored format (dd/MM/yyyy)
const formattedCheckIn = checkInDate
  ? format(parse(checkInDate, "dd/MM/yyyy", new Date()), "EEE do MMM yy")
  : "";

const formattedCheckOut = checkOutDate
  ? format(parse(checkOutDate, "dd/MM/yyyy", new Date()), "EEE do MMM yy")
  : "";



  const baseAccommodationRate = useSelector(
    (state) => state.rates.baseAccommodationRate
  );

  let currentPromotionName = "default"

  const multipleRooms = totalRooms === 2;
  const multipleGuests = totalGuests === 2;

  let accommodationCost = 0
  let accommodationDiscountGuest1 = 0
  let accommodationDiscountGuest2 = 0

  const hasReturningGuest = guest1Returning || guest2Returning;

  for (const date of accommodationDates) {
    let { newGuestDiscount, returningGuestDiscount, promotionName } = getDiscountsForDate(date);

    accommodationCost += baseAccommodationRate
    
    if (multipleRooms) {
      // 2 rooms, 2 guests: Room 1 uses guest1's discount, Room 2 uses guest2's discount
      const discountToUseRoom1 = guest1Returning ? returningGuestDiscount : newGuestDiscount;
      accommodationDiscountGuest1 += baseAccommodationRate * discountToUseRoom1
      
      accommodationCost += baseAccommodationRate
      const discountToUseRoom2 = guest2Returning ? returningGuestDiscount : newGuestDiscount;
      accommodationDiscountGuest2 += baseAccommodationRate * discountToUseRoom2
    } else if (multipleGuests) {
      // 1 room, 2 guests: If either guest is returning, use returning discount for the room
      const discountToUse = (guest1Returning || guest2Returning) ? returningGuestDiscount : newGuestDiscount;
      accommodationDiscountGuest1 += baseAccommodationRate * discountToUse
      // Both guests share the same room discount, so guest2 discount is 0 (already included in guest1)
    } else {
      // 1 room, 1 guest: Use guest1's discount
      const discountToUseRoom1 = guest1Returning ? returningGuestDiscount : newGuestDiscount;
      accommodationDiscountGuest1 += baseAccommodationRate * discountToUseRoom1
    }

    if (currentPromotionName === "default") {
     
      if (currentPromotionName !== promotionName) {
        currentPromotionName = promotionName;
      }
    }
  }

  // TO CHECK ACCOMMODATION COST
  // console.log(`accommodationCost: ${accommodationCost}`);
  // console.log(`accommodationDiscount: ${accommodationDiscount}`);
  // console.log(`accommodationReturningDiscount: ${accommodationReturningDiscount}`);


  let programCost = 0
  let programDiscountGuest1 = 0
  let programDiscountGuest2 = 0

  const baseProgramRate = useSelector(
    (state) => state.rates.baseProgramRate
  );

  let firstDiscounts = null;
let crossesPromotionPeriod = false;
let promotionDetails = []; // Track each date and its discount (for single guest/room)
let accommodationPromotionDetails = []; // Track accommodation dates
let room1PromotionDetails = []; // Track Room 1 dates (for 2 rooms)
let room2PromotionDetails = []; // Track Room 2 dates (for 2 rooms)
let guest1ProgramPromotionDetails = []; // Track Guest 1 Program dates
let guest2ProgramPromotionDetails = []; // Track Guest 2 Program dates

// Track accommodation dates for promotion details
for (const date of accommodationDates) {
  const { newGuestDiscount, returningGuestDiscount, promotionName } = getDiscountsForDate(date);
  
  if (multipleRooms) {
    // 2 rooms: track separately
    room1PromotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount,
      discountToUse: guest1Returning ? returningGuestDiscount : newGuestDiscount
    });
    room2PromotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount,
      discountToUse: guest2Returning ? returningGuestDiscount : newGuestDiscount
    });
  } else if (multipleGuests) {
    // 1 room, 2 guests: track shared room
    accommodationPromotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount,
      discountToUse: (guest1Returning || guest2Returning) ? returningGuestDiscount : newGuestDiscount
    });
  } else {
    // Single guest: track accommodation
    accommodationPromotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount,
      discountToUse: guest1Returning ? returningGuestDiscount : newGuestDiscount
    });
  }
}

for (const date of programDates) {
  const { newGuestDiscount, returningGuestDiscount, promotionName } = getDiscountsForDate(date);

  // Track program dates for each guest
  guest1ProgramPromotionDetails.push({
    date,
    promotionName: promotionName || 'Unnamed Promotion',
    newGuestDiscount,
    returningGuestDiscount,
    discountToUse: guest1Returning ? returningGuestDiscount : newGuestDiscount
  });

  if (multipleGuests) {
    guest2ProgramPromotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount,
      discountToUse: guest2Returning ? returningGuestDiscount : newGuestDiscount
    });
  }

  // For single guest, also populate the main promotionDetails array
  if (!multipleGuests && !multipleRooms) {
    promotionDetails.push({
      date,
      promotionName: promotionName || 'Unnamed Promotion',
      newGuestDiscount,
      returningGuestDiscount
    });
  }

  if (!firstDiscounts) {
    firstDiscounts = { newGuestDiscount, returningGuestDiscount };
  } else if (
    newGuestDiscount !== firstDiscounts.newGuestDiscount ||
    returningGuestDiscount !== firstDiscounts.returningGuestDiscount
  ) {
    crossesPromotionPeriod = true;
  }

  programCost += baseProgramRate;
  // Guest 1: Use returning discount if guest1 is returning, otherwise use new guest discount
  const discountToUseGuest1 = guest1Returning ? returningGuestDiscount : newGuestDiscount;
  programDiscountGuest1 += baseProgramRate * discountToUseGuest1;

  if (multipleGuests) {
    programCost += baseProgramRate;
    // Guest 2: Use returning discount if guest2 is returning, otherwise use new guest discount
    const discountToUseGuest2 = guest2Returning ? returningGuestDiscount : newGuestDiscount;
    programDiscountGuest2 += baseProgramRate * discountToUseGuest2;
  }
}

// Check if accommodation dates cross promotion periods
if (accommodationDates.length > 0) {
  let firstAccommodationDiscounts = null;
  for (const date of accommodationDates) {
    const { newGuestDiscount, returningGuestDiscount } = getDiscountsForDate(date);
    if (!firstAccommodationDiscounts) {
      firstAccommodationDiscounts = { newGuestDiscount, returningGuestDiscount };
    } else if (
      newGuestDiscount !== firstAccommodationDiscounts.newGuestDiscount ||
      returningGuestDiscount !== firstAccommodationDiscounts.returningGuestDiscount
    ) {
      crossesPromotionPeriod = true;
      break;
    }
  }
}

  // Calculate total discounts per guest
  const totalDiscountGuest1 = accommodationDiscountGuest1 + programDiscountGuest1;
  const totalDiscountGuest2 = accommodationDiscountGuest2 + programDiscountGuest2;
  
  // Calculate discount percentages for display based on actual discount amounts
  // This ensures correct percentages for mixed promotions
  let guest1DiscountPercent = null;
  let guest2DiscountPercent = null;
  
  if (multipleRooms && multipleGuests) {
    // 2 rooms, 2 guests: calculate effective discount for each guest
    const guest1TotalCost = (accommodationDates.length * baseAccommodationRate) + (programDates.length * baseProgramRate);
    const guest1TotalDiscount = accommodationDiscountGuest1 + programDiscountGuest1;
    if (guest1TotalCost > 0) {
      guest1DiscountPercent = Math.round((guest1TotalDiscount / guest1TotalCost) * 100);
    }
    
    const guest2TotalCost = (accommodationDates.length * baseAccommodationRate) + (programDates.length * baseProgramRate);
    const guest2TotalDiscount = accommodationDiscountGuest2 + programDiscountGuest2;
    if (guest2TotalCost > 0) {
      guest2DiscountPercent = Math.round((guest2TotalDiscount / guest2TotalCost) * 100);
    }
  } else if (multipleGuests && !multipleRooms) {
    // 1 room, 2 guests: calculate program discount percentages separately
    const guest1ProgramCost = programDates.length * baseProgramRate;
    if (guest1ProgramCost > 0) {
      guest1DiscountPercent = Math.round((programDiscountGuest1 / guest1ProgramCost) * 100);
    }
    
    const guest2ProgramCost = programDates.length * baseProgramRate;
    if (guest2ProgramCost > 0) {
      guest2DiscountPercent = Math.round((programDiscountGuest2 / guest2ProgramCost) * 100);
    }
  } else {
    // 1 guest: calculate effective discount
    const totalCost = accommodationCost + programCost;
    const totalDiscount = accommodationDiscountGuest1 + programDiscountGuest1;
    if (totalCost > 0) {
      guest1DiscountPercent = Math.round((totalDiscount / totalCost) * 100);
    }
  }
  
  // Determine if we need to show separate discount lines
  // Show separate discounts when:
  // - 2 guests AND they have different discount percentages, OR
  // - 2 rooms, 2 guests (always show separately since rooms are separate)
  const showSeparateDiscounts = multipleGuests && 
    guest1DiscountPercent !== null && 
    guest2DiscountPercent !== null &&
    (guest1DiscountPercent !== guest2DiscountPercent || multipleRooms);
  
  // For 1 room, 2 guests: calculate room discount separately
  let roomDiscountAmount = 0;
  let roomDiscountPercent = null;
  let roomIsReturning = false;
  if (multipleGuests && !multipleRooms) {
    roomIsReturning = guest1Returning || guest2Returning;
    roomDiscountAmount = accommodationDiscountGuest1; // This is the total room discount
    const roomCost = accommodationDates.length * baseAccommodationRate;
    if (roomCost > 0) {
      roomDiscountPercent = Math.round((roomDiscountAmount / roomCost) * 100);
    }
  }
  
  // For 2 rooms: calculate room discounts separately based on actual amounts
  let room1DiscountPercent = null;
  let room2DiscountPercent = null;
  if (multipleRooms && multipleGuests) {
    const room1Cost = accommodationDates.length * baseAccommodationRate;
    if (room1Cost > 0) {
      room1DiscountPercent = Math.round((accommodationDiscountGuest1 / room1Cost) * 100);
    }
    
    const room2Cost = accommodationDates.length * baseAccommodationRate;
    if (room2Cost > 0) {
      room2DiscountPercent = Math.round((accommodationDiscountGuest2 / room2Cost) * 100);
    }
  }

  // TO CHECK PROGRAM COST
  // console.log(`programCost: ${programCost}`);
  // console.log(`programDiscount: ${programDiscount}`);
  // console.log(`programReturningDiscount: ${programReturningDiscount}`);


  //const discountLabel = currentPromotionName === "default" ? "Special Discount" : "Limited Time Promo";

  let discountLabel;

  // Get unique promotions from all promotion details arrays
  const allPromotionNames = [
    ...accommodationPromotionDetails.map(p => p.promotionName),
    ...room1PromotionDetails.map(p => p.promotionName),
    ...room2PromotionDetails.map(p => p.promotionName),
    ...guest1ProgramPromotionDetails.map(p => p.promotionName),
    ...guest2ProgramPromotionDetails.map(p => p.promotionName),
    ...promotionDetails.map(p => p.promotionName)
  ];
  const uniquePromotions = [...new Set(allPromotionNames)];
  
  let isFlashDeal = false;
  
  // Check if any date has a 50% discount (for returning guests) or 50% for new guests
  // This ensures flash deal shows even with mixed promotions
  // Check all promotion details arrays
  const allPromotionDetails = [
    ...accommodationPromotionDetails,
    ...room1PromotionDetails,
    ...room2PromotionDetails,
    ...guest1ProgramPromotionDetails,
    ...guest2ProgramPromotionDetails,
    ...promotionDetails
  ];
  const has50PercentDiscount = allPromotionDetails.some(entry => {
    if (hasReturningGuest) {
      return Math.round(entry.returningGuestDiscount * 100) === 50;
    } else {
      return Math.round(entry.newGuestDiscount * 100) === 50;
    }
  });
  
  // If showing separate discounts, we don't need a single discount label
  // But we still need it for the single discount case
  if (!showSeparateDiscounts) {
    // Use the calculated effective discount percentage instead of firstDiscounts
    // This ensures correct percentages for mixed promotions
    if (guest1DiscountPercent !== null) {
      if (hasReturningGuest) {
        discountLabel = `${guest1DiscountPercent}% Returning Discount`;
        isFlashDeal = has50PercentDiscount; // Check if any date has 50% discount
      } else {
        discountLabel = `${guest1DiscountPercent}% Discount`;
        isFlashDeal = has50PercentDiscount; // Check if any date has 50% discount
      }
    } else if (uniquePromotions.length === 1) {
      discountLabel = uniquePromotions[0];
      
      // Fallback: use firstDiscounts if guest1DiscountPercent is not calculated
      if (hasReturningGuest && firstDiscounts) {
        const returningDiscountPercent = Math.round(firstDiscounts.returningGuestDiscount * 100);
        discountLabel = `${returningDiscountPercent}% Returning Discount`;
        isFlashDeal = returningDiscountPercent === 50;
      } else if (!hasReturningGuest && firstDiscounts && uniquePromotions[0] === 'default') {
        const newGuestDiscountPercent = Math.round(firstDiscounts.newGuestDiscount * 100);
        discountLabel = `${newGuestDiscountPercent}% Discount`;
        isFlashDeal = newGuestDiscountPercent === 50;
      } else if (!hasReturningGuest && firstDiscounts) {
        const newGuestDiscountPercent = Math.round(firstDiscounts.newGuestDiscount * 100);
        isFlashDeal = newGuestDiscountPercent === 50;
        if (uniquePromotions[0].includes('50%')) {
          isFlashDeal = true;
        }
      }
    } else {
      // Multiple promotions - use effective discount if available
      if (guest1DiscountPercent !== null) {
        if (hasReturningGuest) {
          discountLabel = `${guest1DiscountPercent}% Returning Discount`;
          isFlashDeal = has50PercentDiscount; // Check if any date has 50% discount
        } else {
          discountLabel = `${guest1DiscountPercent}% Discount`;
          isFlashDeal = has50PercentDiscount; // Check if any date has 50% discount
        }
      } else {
        discountLabel = "Mixed Promotion";
        isFlashDeal = has50PercentDiscount; // Check if any date has 50% discount
      }
    }
  } else {
    // For separate discounts, set a default label (won't be used but needed for flash deal check)
    discountLabel = "Discount";
    // Check if either guest has 50% discount for flash deal
    if (guest1DiscountPercent === 50 || guest2DiscountPercent === 50) {
      isFlashDeal = true;
    }
  }



  

  const totalCost = accommodationCost + programCost
  const discount = totalDiscountGuest1 + totalDiscountGuest2
  // No longer need separate returning discount calculation since it's included in discount above
  const returningDiscount = 0;




  const finalCost = totalCost - discount;

  const airportPickUp = useSelector((state) => state.quote.airportPickUp);
  const airportDropOff = useSelector((state) => state.quote.airportDropOff);

  let transferCost = 0;

  if (airportPickUp) {
    transferCost += taxiLegPriceThb(checkInDate);
  }

  if (airportDropOff) {
    transferCost += taxiLegPriceThb(checkOutDate);
  }

  let totalQuotation = finalCost + transferCost;

  useEffect(() => {
    dispatch(
      quoteActions.setQuotationPrices({
        wellnessPackageCost: totalCost,
        totalDiscount: discount,
        returningDiscount: returningDiscount,
        transferCost: transferCost,
        grandTotal: totalQuotation,
        promotionName: discountLabel,
      })
    );
  }, [
    totalCost,
    discount,
    transferCost,
    returningDiscount,
    totalQuotation,
    discountLabel,
    dispatch,
  ]);

  const forexTotalCost = totalCost * forexCurrencyRate;
  const forexDiscount = discount * forexCurrencyRate;
  const forexFinalCost = finalCost * forexCurrencyRate;
  const forexTransferCost = transferCost * forexCurrencyRate;
  const forexTotalQuotation = forexFinalCost + forexTransferCost;

  const proceedButtonClickHandler = () => {
    dispatch(quoteActions.setQuoteAcceptedToggle());
  };

  const [showPromotionDetails, setShowPromotionDetails] = useState(false);




  return (
    <div className={classes.formContainer}>
      <div className={classes.summaryContainer}>
        {/* <AccommodationPref/> */}

        <AmityUSPHighlight/>

      <ItemDescription
        itemNumber={`${accommodationNights} Nights`}
        itemHeader="Accommodation Room One"
        itemSubheader={
          <>
            Check-in: {formattedCheckIn}
            <br />
            Check-out: {formattedCheckOut}
          </>
        }
        itemDescription={
          accommodationPref +
          (accommodationPref !== "No Preference"
            ? ` Preference (We will do our best to adhere to your request)`
            : ``)
        }
        itemSpecial={
          (accommodationPref === "No Preference"
            ? ""
            : accommodationPref) + (extraBed ? ` - Extra Bed` : ``)
        }
        itemToggle={accommodationPrefClickHandlerToggle}
        itemToggleText="Change Accommodation Preference"
      />

        <ItemDescription
          itemNumber={`${programDays} Days`}
          itemHeader="Wellness Program Guest One"
          itemSubheader={guest1ReturningEmail}
          itemSpecial={guest1Returning ? "Returning Guest" : "First Time Guest"}
          itemToggle={
            guest1Returning
              ? guest1ReturningToggleHandler
              : ReturningPopupShowGuestOne
          }
          itemToggleText={
            guest1Returning
              ? "Change - I am a first time guest"
              : "Please Click Here If You Are a Returning Guest"
          }
        />

        {multipleRooms && (
          <ItemDescription
            itemNumber={`${accommodationNights} Nights`}
            itemHeader="Accommodation Room Two"
            itemSubheader={
              <>
                Check-in: {formattedCheckIn}
                <br />
                Check-out: {formattedCheckOut}
              </>
            }
            itemDescription={
              accommodationPref +
              (accommodationPref !== "No Preference"
                ? ` Preference (We will do our best to adhere to your request)`
                : ``)
            }
            itemSpecial={
              (accommodationPref === "No Preference"
                ? ""
                : accommodationPref) + (extraBed ? ` - Extra Bed` : ``)
            }
            itemToggle={accommodationPrefClickHandlerToggle}
            itemToggleText="Change Accommodation Preference"
          />
        )}
        {multipleGuests && (
          <ItemDescription
            itemNumber={`${programDays} Days`}
            itemHeader="Wellness Program Guest Two"
            itemSubheader={guest2ReturningEmail}
            itemSpecial={
              guest2Returning ? "Returning Guest" : "First Time Guest"
            }
            itemToggle={
              guest2Returning
                ? guest2ReturningToggleHandler
                : ReturningPopupShowGuestTwo
            }
            itemToggleText={
              guest2Returning
                ? "Change - I am a first time guest"
                : "Please Click Here If You Are a Returning Guest"
            }
          />
        )}



        <AirportTransfers />
        <ProgramDropDown/>


     


        <div className={classes.QuoteBreakdownContainer}>
          <PriceItemOutput
            label="Wellness Package:"
            thbValue={numberWithCommas(totalCost)}
            forexValue={numberWithCommas(forexTotalCost)}
            forexSymbol={forexCurrencyTicker}
            forexSelected={forexSelected}
          />

          {multipleGuests ? (
            <>
              {multipleRooms ? (
                <>
                  <PriceItemOutput
                    label={`Room 1 - ${room1DiscountPercent}% ${guest1Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(accommodationDiscountGuest1))}`}
                    forexValue={`-${numberWithCommas(Math.round(accommodationDiscountGuest1 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                  <PriceItemOutput
                    label={`Guest 1 Program - ${guest1DiscountPercent}% ${guest1Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(programDiscountGuest1))}`}
                    forexValue={`-${numberWithCommas(Math.round(programDiscountGuest1 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                  <PriceItemOutput
                    label={`Room 2 - ${room2DiscountPercent}% ${guest2Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(accommodationDiscountGuest2))}`}
                    forexValue={`-${numberWithCommas(Math.round(accommodationDiscountGuest2 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                  <PriceItemOutput
                    label={`Guest 2 Program - ${guest2DiscountPercent}% ${guest2Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(programDiscountGuest2))}`}
                    forexValue={`-${numberWithCommas(Math.round(programDiscountGuest2 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                </>
              ) : (
                <>
                  {roomDiscountPercent !== null && (
                    <PriceItemOutput
                      label={`Room - ${roomDiscountPercent}% ${roomIsReturning ? 'Returning ' : ''}Discount:`}
                      thbValue={`-${numberWithCommas(Math.round(roomDiscountAmount))}`}
                      forexValue={`-${numberWithCommas(Math.round(roomDiscountAmount * forexCurrencyRate))}`}
                      forexSymbol={forexCurrencyTicker}
                      forexSelected={forexSelected}
                      isDiscount={true}
                    />
                  )}
                  <PriceItemOutput
                    label={`Guest 1 Program - ${guest1DiscountPercent}% ${guest1Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(programDiscountGuest1))}`}
                    forexValue={`-${numberWithCommas(Math.round(programDiscountGuest1 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                  <PriceItemOutput
                    label={`Guest 2 Program - ${guest2DiscountPercent}% ${guest2Returning ? 'Returning ' : ''}Discount:`}
                    thbValue={`-${numberWithCommas(Math.round(programDiscountGuest2))}`}
                    forexValue={`-${numberWithCommas(Math.round(programDiscountGuest2 * forexCurrencyRate))}`}
                    forexSymbol={forexCurrencyTicker}
                    forexSelected={forexSelected}
                    isDiscount={true}
                  />
                </>
              )}
            </>
          ) : (
            <PriceItemOutput
              label={`${discountLabel}:`}
              thbValue={`-${numberWithCommas(discount)}`}
              forexValue={`-${numberWithCommas(forexDiscount)}`}
              forexSymbol={forexCurrencyTicker}
              forexSelected={forexSelected}
              isDiscount={true}
            />
          )}
          {crossesPromotionPeriod && (
            <div>
              <div className={classes.promotionHeader}>
              <p className={classes.discountNote}>
            <span style={{
              color: 'white',
              backgroundColor: 'red',
              borderRadius: '50%',
              padding: '0 6px',
              display: 'inline-block',
              fontWeight: 'bold',
              fontSize: '12px',
              marginRight: '6px'
            }}>
              i
            </span>
            Spans two promotion periods.
          </p>
                <button
                  onClick={() => setShowPromotionDetails(!showPromotionDetails)}
                  className={classes.toggleButton}
                >
                  {showPromotionDetails ? 'Hide Details' : 'Show Details'}
                </button>
              </div>

              {showPromotionDetails && (
                <div className={classes.promotionDetailsContainer}>
                  {multipleRooms ? (
                    // 2 rooms, 2 guests: Show Room 1, Guest 1 Program, Room 2, Guest 2 Program
                    <>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Room 1:</p>
                        <ul className={classes.promotionDetails}>
                          {room1PromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Guest 1 Program:</p>
                        <ul className={classes.promotionDetails}>
                          {guest1ProgramPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Room 2:</p>
                        <ul className={classes.promotionDetails}>
                          {room2PromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest2Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Guest 2 Program:</p>
                        <ul className={classes.promotionDetails}>
                          {guest2ProgramPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest2Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </>
                  ) : multipleGuests ? (
                    // 1 room, 2 guests: Show Room, Guest 1 Program, Guest 2 Program
                    <>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Room:</p>
                        <ul className={classes.promotionDetails}>
                          {accommodationPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning || guest2Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Guest 1 Program:</p>
                        <ul className={classes.promotionDetails}>
                          {guest1ProgramPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Guest 2 Program:</p>
                        <ul className={classes.promotionDetails}>
                          {guest2ProgramPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest2Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </>
                  ) : (
                    // Single guest: Show Accommodation and Program separately
                    <>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Accommodation:</p>
                        <ul className={classes.promotionDetails}>
                          {accommodationPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      <div className={classes.promotionSection}>
                        <p className={classes.promotionSectionTitle}>Program:</p>
                        <ul className={classes.promotionDetails}>
                          {guest1ProgramPromotionDetails.map((entry, index) => {
                            const discountPercent = Math.round(entry.discountToUse * 100);
                            const isReturning = guest1Returning;
                            return (
                              <li key={index} className={classes.promotionItem}>
                                {entry.date}: {discountPercent}% {isReturning ? 'Returning ' : ''}Discount
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          )}




          {/* Returning discount is now included in the main discount, so we don't show it separately */}
          {transferCost > 0 && (
            <PriceItemOutput
              label="Airport Transfer:"
              thbValue={numberWithCommas(transferCost)}
              forexValue={numberWithCommas(forexTransferCost)}
              forexSymbol={forexCurrencyTicker}
              forexSelected={forexSelected}
            />
          )}

          <PriceItemOutput
            label="Total Quotation:"
            thbValue={numberWithCommas(totalQuotation)}
            forexValue={numberWithCommas(forexTotalQuotation)}
            forexSymbol={forexCurrencyTicker}
            forexSelected={forexSelected}
            flashDeal={isFlashDeal}
          />
          <p className={classes.tax}>(Taxes and Fees Included)</p>
          <p className={classes.forexAlert}>
            Exchange rates are approximate, Payments will be made in THB
          </p>
          <BookingCurrencyConverter />
        </div>
      </div>

   <div className={classes.datesSummary}>
          <p>
            <strong>Check-in:</strong> {formattedCheckIn}<br />
            <strong>Check-out:</strong> {formattedCheckOut}
          </p>

          <p>
            <strong>Accommodation:</strong> {accommodationNights} Nights
          </p>
          <p>
            <strong>Wellness Program:</strong> {programDays} Days
          </p>
          <p>
            <strong>Rooms:</strong> {totalRooms} {totalRooms === 1 ? "Room" : "Rooms"}{" "}
            {accommodationPref !== "No Preference" || extraBed ? (
              <span className={classes.muted}>
                ({accommodationPref !== "No Preference" ? accommodationPref : ""}
                {accommodationPref !== "No Preference" && extraBed ? " • " : ""}
                {extraBed ? "Extra Bed" : ""})
              </span>
            ) : null}
          </p>



          <p>
            <strong>Guests:</strong> {totalGuests} {totalGuests === 1 ? "Guest" : "Guests"}{" "}
            {totalGuests === 1 ? (
              guest1Returning ? (
                <span className={classes.muted}>(Returning)</span>
              ) : null
            ) : (
              (guest1Returning || guest2Returning) && (
                <span className={classes.muted}>
                  (
                  {guest1Returning ? "Guest 1: Returning" : ""}
                  {guest1Returning && guest2Returning ? " • " : ""}
                  {guest2Returning ? "Guest 2: Returning" : ""}
                  )
                </span>
              )
            )}
          </p>


        </div>

        <div className={classes.availabilityNotice} role="status" aria-live="polite">
          <span className={classes.availabilityNoticeLabel}>Please note</span>
          <p className={classes.availabilityNoticeText}>
            This quotation is generated for your requested dates and does not confirm availability. Availability is checked manually by our reservations team when we respond to your enquiry.
          </p>
        </div>

      <div className={classes.searchButtonContainer}>
        <Button onClick={proceedButtonClickHandler} buttonText="Proceed" />
      </div>

      <div className={classes.QuoteBreakdownContainer}></div>
      <CopyQuoteLinkButton />

    </div>
  );
};

export default QuotationOverview;
